import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { Background } from '../../assets/images';

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    '@global': {
      '#root': {
        background: `no-repeat center/cover fixed url(${Background})`,
      },
    },
    container: {
      height: '100vh',
      padding: '5vh 0rem 1rem',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      textAlign: 'center',
    },
    cardWrapper: {
      flexDirection: 'column',
      alignItems: 'center',
    },
    descriptionContainer: {
      paddingTop: theme.spacing(2),
      '& h1': {
        marginBottom: theme.spacing(1),
        color: theme.palette.primary.light,
        fontSize: 20,
        fontWeight: 'bold',
      },

      '& p': {
        color: theme.palette.text.secondary,
      },
    },
    inputsContainer: {
      marginTop: theme.spacing(2),
    },
    inputs: {
      borderRadius: 17,

      '& svg': {
        width: 18,
        height: 18,
        color: theme.palette.primary.light,
      },
    },
    submitButton: {
      padding: '5px 40px',
      fontSize: 16,
      borderRadius: 35,
      textTransform: 'initial',

      [theme.breakpoints.up('sm')]: {
        width: '100%',
      },
    },
  })
);

export default useStyles;
